import { CONST } from '@/utils/constants'
import { makeContinuationURL } from '@/utils'
import navigation from '@/utils/navigation'

import Vue from 'vue'
import store from '@/store'
import router from '@/router'

const status = (message) => { console.log(message) }
const logout = async () => {
  const message = Vue.i18n.translate('session expired message')
  try {
    // Trigger Logout
    await store.dispatch('user/logout')
  } catch (err) {
    // Log the Server Error
    status('Failed to Logout', err)
  }
  // Display Message
  store.dispatch('user/raiseLogoutError',  [ message ])
  // Navigate to Login (with continuation URL)
  navigation.go(makeContinuationURL(router.currentRoute))
}
let sessionTimer

function checkSessionExpiration () {
  /*
    E2E Tests can't access 'AuthenticationExpirationTicket' cookie [TODO]
    ---------------------------------------------------------------------
    When the backend is on different domain to frontend the Cookies are not
    accessible to the Vue App. For now we have decided to implement an ENVAR
    to bypass this check.
    
    In future the Login API should respond with an aditional property which
    includes the 'expiry time'. The frontend can then be in charge of setting
    /updating/deleting it. Alternatively and maybe preferably (as the backend
    has no use for this cookie), this could be owned/managed solely by the
    frontend in which case the API should remove the code that sets the
    'AuthenticationExpirationTicket' cookie entirely and the Vue app will
    instead be in charge of the Timeout process/cookie.    
  */
  if (process.env.VUE_APP_MODE === 'e2e') return
  // Flags
  const expiry = Vue.cookie.get(CONST.Cookies.SessionExpiration.Name) || 0
  const remaining = expiry - Date.now()
  const hasCookie = (expiry > 0)
  const hasTimeLeft = (remaining > 0)
  // Force Logout if Cookie doesn't Exist or Time Ran Out
  if (!hasCookie || (hasCookie  && !hasTimeLeft)) {
    // Log a Message
    status(`Cookie ${CONST.Cookies.SessionExpiration.Name} is not set`)
    // Logout
    logout()
  } else {
    // Log a Message
    const expiresIn = new Date(remaining)
    status(`Session will time out in ${expiresIn.getUTCHours()}:${expiresIn.getUTCMinutes()}:${expiresIn.getUTCSeconds()}`)
  }
}

// This is a session monitor that monitors user activity , if user is inactive for a certain period of time determined by the cookie used , user is logged out.
export const SessionMonitor = {
  start: () => {
    if (!sessionTimer) {
      // Using setTimeout here instead of setInterval because we want the function to complete before queing it up again.
      // The setInterval function will fire and forget so can end up with multiple calls in quick succession.
      // We also check if the sessionTimer is null when scheduling the next one , this means it hasn't been stopped.
      // A null sessionTimer means its stopped therefore another run should not be scheduled.
      let timerLoop = () => {
        checkSessionExpiration()
        sessionTimer = sessionTimer ? setTimeout(timerLoop, CONST.Cookies.SessionExpiration.CheckFrequency) : null
      }
      sessionTimer = setTimeout(timerLoop, CONST.Cookies.SessionExpiration.CheckFrequency)
      status('Session monitor started')
    }
  },
  stop: () => {
    if (sessionTimer) {
      clearTimeout(sessionTimer)
      sessionTimer = null
      status('Session monitor stopped')
    }
  }
}

export default {
  SessionMonitor
}
